import React from 'react';
import { motion } from 'framer-motion';
import FeatureCard from './FeatureCard';
import { Brain, Shield, Zap, TrendingUp, BarChart as ChartBar, PiggyBank } from 'lucide-react';

const Features: React.FC = () => {
  const features = [
    {
      icon: <Brain className="h-6 w-6" />,
      title: "Smart Insights",
      description: "AI-powered analysis of your spending patterns and financial habits.",
      delay: 0.1
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: "Bank-Grade Security",
      description: "Your data is protected with enterprise-level encryption and security.",
      delay: 0.2
    },
    {
      icon: <Zap className="h-6 w-6" />,
      title: "Real-Time Tracking",
      description: "Monitor your finances with instant updates and alerts.",
      delay: 0.3
    },
    {
      icon: <TrendingUp className="h-6 w-6" />,
      title: "Growth Focus",
      description: "Personalized recommendations to help your money grow.",
      delay: 0.4
    },
    {
      icon: <ChartBar className="h-6 w-6" />,
      title: "Advanced Analytics",
      description: "Deep insights into your spending and saving patterns.",
      delay: 0.5
    },
    {
      icon: <PiggyBank className="h-6 w-6" />,
      title: "Smart Budgeting",
      description: "Automated budget suggestions based on your spending habits.",
      delay: 0.6
    }
  ];

  return (
    <section
      id="features"
      className="py-20 bg-gray-50 dark:bg-gray-800/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ 
            opacity: 1, 
            y: 0,
            transition: {
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1]
            }
          }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Powerful Features
          </h2>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300">
            Everything you need to master your finances
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={feature.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;